module.exports = __webpack_public_path__ + "assets/img/teacher (1).3dd9c429.png";